import { Box, Button, Flex, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { tKeys } from '@/i18n';

import { StorageKeysEnum } from '@/enums/storageKeys.enum';

import { useLocalStorage } from '@/hooks/useLocalStorage';
import { useSettings } from '@/hooks/useSettings';

import { SET_ONBOARDING_STEP } from '../../bracket.slice';

export const SecondStepText = () => {
  const { t } = useTranslation();
  const { isMobile } = useSettings();
  return (
    <>
      <Flex
        align='center'
        direction='column'
        gap={['0', '20px']}
        left={['220px', '300px']}
        position='absolute'
        top={['390px', '-40px']}
        zIndex={4}
      >
        {!isMobile && <Arrow />}

        <Box textAlign='center' w={['136px', '250px']}>
          <Text
            fontFamily='Antonio'
            fontSize={['16px', '40px']}
            fontWeight='700'
            lineHeight={['1', '52px']}
            mb={['10px']}
          >
            {t(tKeys.greatPick)}!
          </Text>
          <Text
            fontFamily='Averta, sans-serif'
            fontSize={['12px', '16px']}
            fontWeight={700}
          >
            {t(tKeys.ensureYouMakeAllSelections)}
          </Text>
        </Box>

        {!isMobile && <GotItButton />}
      </Flex>
    </>
  );
};

export const GotItButton = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { setItem } = useLocalStorage(StorageKeysEnum.onboardingComplete);

  const clickHandler = () => {
    dispatch(SET_ONBOARDING_STEP(0));
    setItem(true);
  };

  return (
    <Button onClick={clickHandler} variant='primary' w='full'>
      {t(tKeys.gotIt)} <ButtonArrowIcon />
    </Button>
  );
};

const Arrow = () => (
  <svg
    fill='none'
    height='46'
    viewBox='0 0 51 46'
    width='51'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M9.12113 5.50053C9.46024 5.20535 9.85137 4.97593 10.2745 4.82403L10.3264 4.81662C10.4375 4.78021 10.5512 4.7521 10.6666 4.73252L10.9081 4.69779C11.0301 4.68624 11.1506 4.66302 11.2681 4.62842L11.3199 4.62106C11.4727 4.58151 11.8451 4.47516 12.4046 4.32433L12.4712 4.2972C12.6413 4.25519 13.2896 4.10917 14.3966 3.84448L14.4311 3.83948C14.9439 3.73059 15.3359 3.63917 15.6811 3.58956L15.6982 3.58708C16.454 3.4785 17.2156 3.41615 17.979 3.40035C18.329 3.38537 18.6792 3.37031 19.0318 3.37245L19.0664 3.36747C20.2327 3.39387 21.0069 3.38835 21.3768 3.38795C22.0625 3.37267 22.7263 3.63 23.2224 4.10347C23.7186 4.57695 24.0067 5.22791 24.0236 5.91355C24.0404 6.59919 23.7846 7.26351 23.3122 7.76077C22.8399 8.25803 22.1896 8.54762 21.504 8.56602C21.0823 8.5737 20.2366 8.57196 19.0185 8.55308C18.7373 8.55825 18.439 8.56577 18.158 8.57092L18.1407 8.57344C17.7273 8.58589 17.3148 8.62162 16.9054 8.68045C22.6033 11.5969 27.6041 15.7094 31.566 20.7367C35.6604 25.6973 39.0099 32.5028 41.6145 41.1532C41.8101 41.8111 41.7367 42.5196 41.4105 43.1234C41.0842 43.7273 40.5318 44.177 39.8744 44.3741C39.217 44.5711 38.5083 44.4993 37.9037 44.1745C37.2991 43.8496 36.8481 43.2982 36.6496 42.6412C34.2346 34.6564 31.2053 28.445 27.5616 24.0069L27.5222 23.9774C24.1053 19.6356 19.8172 16.0573 14.9339 13.4728C15.874 15.9745 16.6534 18.5336 17.2673 21.1346C17.341 21.4667 17.3485 21.81 17.2894 22.145C17.2303 22.4799 17.1057 22.8 16.9228 23.0867C16.7399 23.3735 16.5022 23.6214 16.2234 23.8162C15.9446 24.0111 15.6301 24.149 15.2979 24.2222C14.9658 24.2954 14.6224 24.3024 14.2876 24.2427C13.9527 24.1831 13.6329 24.058 13.3464 23.8747C13.0599 23.6913 12.8123 23.4533 12.6179 23.1742C12.4235 22.8951 12.286 22.5804 12.2134 22.2481C11.4041 18.9695 10.3651 15.7519 9.10419 12.6191L9.07204 12.5181C8.7732 11.7316 8.42767 10.9637 8.03732 10.2184L8.00511 10.1172C7.9039 9.90287 7.83223 9.7722 7.78526 9.69086C7.47396 9.3657 7.25606 8.96263 7.15453 8.52408C7.05299 8.08552 7.07157 7.62771 7.2083 7.19882C7.34502 6.76994 7.59485 6.38584 7.93147 6.08697C8.26809 5.7881 8.67908 5.58551 9.12113 5.50053Z'
      fill='white'
    />
    <path
      d='M17.9799 3.39385L17.9849 3.39355L17.9784 3.39345L17.9799 3.39385Z'
      fill='white'
    />
  </svg>
);

const ButtonArrowIcon = () => (
  <svg
    fill='none'
    height='25'
    viewBox='0 0 25 25'
    width='25'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M12.7929 5.35832C13.1834 4.9678 13.8166 4.9678 14.2071 5.35832L20.2071 11.3583C20.3946 11.5459 20.5 11.8002 20.5 12.0654C20.5 12.3306 20.3946 12.585 20.2071 12.7725L14.2071 18.7725C13.8166 19.1631 13.1834 19.1631 12.7929 18.7725C12.4024 18.382 12.4024 17.7488 12.7929 17.3583L17.0858 13.0654L5.5 13.0654C4.94772 13.0654 4.5 12.6177 4.5 12.0654C4.5 11.5131 4.94772 11.0654 5.5 11.0654L17.0858 11.0654L12.7929 6.77254C12.4024 6.38201 12.4024 5.74885 12.7929 5.35832Z'
      fill='#071520'
    />
  </svg>
);
